module.exports = __webpack_public_path__ + "static/media/icon-jewelry.b2b3fef3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-jewelry.svg
// module id = 983
// module chunks = 0